import { ComponentType } from 'react';
import RoleGuard from './role-guard';

export function withRoleGuard<P extends object>(Component: ComponentType<P>, allowedRoles: string[], fallbackPath?: string) {
  return function WithRoleGuard(props: P) {
    return (
      <RoleGuard allowedRoles={allowedRoles} fallbackPath={fallbackPath}>
        <Component {...props} />
      </RoleGuard>
    );
  };
}
